import axios from "axios";
import React,{useState,useEffect} from "react";
import CommonVars from "./CommonVars";
import {Link, Flex, chakra, Menu,MenuItem, MenuList, Box, MenuButton } from '@chakra-ui/react';


function clearlocal(){
  localStorage.clear()
}
function NavBar(){
  const[category,setCategory] = useState('')
  useEffect(() =>{
    getCategory()
  },[])

  const getCategory = async() =>{
    axios.get(`${CommonVars.API_URL}/category`)
    .then((res) =>{
      const CategoryDetails = res.data
      console.log(CategoryDetails)
      setCategory(CategoryDetails)
    }).catch((err) =>{
      console.log(err)
    })
  }
    const aCategory = []
    for(var i = 0; i<category.length;i++)
    {
      aCategory.push(
          <MenuItem key={category[i].categoryid}>
          <chakra.a href={'/products/category/' + category[i].categoryid}> 
          {category[i].categoryname}</chakra.a>
          </MenuItem>
      )
    }
      

    return(
      <Box  textAlign={"center"} h={'40px'} w={'full'} bg={'black'} >
        <Flex justifyContent={'space-between'}>
            <Box margin={"5px"} textColor={"white"}  w={"50px"} h={"40px"}>
              <Link href="/" >
                  Home
              </Link>
            </Box>
            <Box margin={"5px"}  w={"60px"} h={"40px"}>
            <Menu >
                <MenuButton textColor={'white'}>
                Category
                </MenuButton>
                <MenuList>
                  {aCategory}
                </MenuList>
              </Menu>

            </Box>
            <Box margin={"5px"} textColor={"white"}  h={"30px"}>
              <Link href="/orders">
              Orders
              </Link>
              </Box>
            {
              localStorage.getItem('token') == null ?
              <>
              <Box margin={"5px"} textColor={"white"}  h={"30px"}>
              <Link href="/login">
              Cart
              </Link>
              </Box>
              </> :
              <Box margin={"5px"} textColor={"white"}  h={"30px"}>
              <Link href="/carts">
              Cart
              </Link>
              </Box>
            }
            
            {
              localStorage.getItem('token') !== null ?
              <>
                {
              localStorage.getItem('role') === "admin" ? 
              <>
              <Box margin={'5px'} textAlign={'center'}  textColor={"white"} h={"30px"}>
              <Link href="/Addproduct">
              Add Product
              </Link>
            </Box>
            <Box margin={'5px'} textAlign={'center'}  textColor={"white"} h={"30px"}>
              <Link href="/AddCategory">
              Add Category
              </Link>
            </Box>
            <Box minH={'20vh'}  paddingInlineStart={'1000'} margin={"5px"} textColor={"white"}  h={"30px"}>
              <Link href="/" onClick={clearlocal}>
              Log Out
              </Link> 
            </Box>
            </> : 
             <Box minH={'20vh'} paddingInlineStart={'1200'} margin={"5px"} textColor={"white"}  h={"30px"}>
             <Link href="/" onClick={clearlocal}>
             Log Out
             </Link> 
           </Box>
            }
              </> :
              <Box paddingInlineStart={'1250'} margin={"5px"} textColor={"white"}  h={"30px"}>
              <Link href="/login">
               Login
              </Link> 
            </Box>
            }
       
              
            

        </Flex>

      </Box>
  );
} 


export default NavBar;